import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import path from 'path';
// import store from '@/store'
import { isExternal } from '@/utils/validate';
// import Item from './Item'
// import AppLink from './Link'
import FixiOSBug from './FixiOSBug';
import { hasAccess } from '../../../router/permission';
export default {
  name: 'SidebarItem',
  // components: { AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    this.customerCentre = ['账号信息', '贸易公司信息', '商品信息'];
    this.carnet = ['进口报关', '出口报关', '报关详情'];
    this.staff = ['员工管理', '角色管理', '口岸管理', '添加员工'];
    this.clearance = ['出口异常', '进口异常', '创建异常'];
    this.defaultIcon = {
      customsClearanceSupply: 'clearance-choose',
      VIPcenter: 'VIPcenter'
    };
    return {
      badgeDit: {
        exportBNewSubmitCount: 0,
        exportBReSubmitCount: 0,
        exportCNewSubmitCount: 0,
        exportCReSubmitCount: 0,
        exportDNewSubmitCount: 0,
        exportDReSubmitCount: 0,
        importBNewSubmitCount: 0,
        importBReSubmitCount: 0,
        importCNewSubmitCount: 0,
        importCReSubmitCount: 0,
        importDNewSubmitCount: 0,
        importDReSubmitCount: 0
      }
    };
  },
  computed: {
    userCenterStyle: function userCenterStyle() {
      return function (item) {
        if (item.icon === 'VIPcenter' || item.icon === 'VIPcenterfalse') {
          return 'userCenterStyle';
        }
      };
    },
    isRootMenuHiddenBadge: function isRootMenuHiddenBadge() {
      var _this = this;
      return function (val) {
        var badgeDitKeys = Object.keys(_this.badgeDit);
        var notZeroArray = badgeDitKeys.filter(function (key) {
          return _this.badgeDit[key] !== 0;
        });
        if (val.name === 'admin-customs-clearance' && notZeroArray.length > 0) {
          return false;
        }
        if (val.name === 'admin-clearance-export' && (_this.badgeDit.exportBNewSubmitCount !== 0 || _this.badgeDit.exportBReSubmitCount !== 0 || _this.badgeDit.exportCNewSubmitCount !== 0 || _this.badgeDit.exportCReSubmitCount !== 0 || _this.badgeDit.exportDNewSubmitCount !== 0 || _this.badgeDit.exportDReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-import' && (_this.badgeDit.importBNewSubmitCount !== 0 || _this.badgeDit.importBReSubmitCount !== 0 || _this.badgeDit.importCNewSubmitCount !== 0 || _this.badgeDit.importCReSubmitCount !== 0 || _this.badgeDit.importDNewSubmitCount !== 0 || _this.badgeDit.importDReSubmitCount !== 0)) {
          return false;
        }
        return true;
      };
    },
    isSubMenuHiddenBadge: function isSubMenuHiddenBadge() {
      var _this2 = this;
      return function (val) {
        if (val.name === 'admin-clearance-export-b' && (_this2.badgeDit.exportBNewSubmitCount !== 0 || _this2.badgeDit.exportBReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-export-c' && (_this2.badgeDit.exportCNewSubmitCount !== 0 || _this2.badgeDit.exportCReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-export-d' && (_this2.badgeDit.exportDNewSubmitCount !== 0 || _this2.badgeDit.exportDReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-import-b' && (_this2.badgeDit.importBNewSubmitCount !== 0 || _this2.badgeDit.importBReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-import-c' && (_this2.badgeDit.importCNewSubmitCount !== 0 || _this2.badgeDit.importCReSubmitCount !== 0)) {
          return false;
        }
        if (val.name === 'admin-clearance-import-d' && (_this2.badgeDit.importDNewSubmitCount || _this2.badgeDit.importDReSubmitCount !== 0)) {
          return false;
        }
        return true;
      };
    }
  },
  created: function created() {
    var _this3 = this;
    var route = this.$route;
    var meta = route.meta;
    if (meta && meta.title) {
      this.clickitem(meta.title);
    }
    this.$bus.$on('update-admin-clearance-add-count', function (val) {
      // 更新新增数量
      _this3.badgeDit = val;
    });
  },
  methods: {
    clickitem: function clickitem(e) {
      // const text = e.target ? e.target.innerText : e
      // const data = {
      //   title: '',
      //   icon: ''
      // }
      // if (this.customerCentre.includes(text)) {
      //   data.title = '个人中心'
      //   data.icon = 'VIPcenter'
      // } else if (this.carnet.includes(text)) {
      //   data.title = '报关单证'
      //   data.icon = 'clearance-choose'
      // } else if (this.staff.includes(text)) {
      //   data.title = '平台管理'
      //   data.icon = 'staff'
      // } else if (this.clearance.includes(text)) {
      //   data.title = '清关异常'
      //   data.icon = 'clearance'
      // } else {
      //   data.title = '客户档案'
      //   data.icon = 'profile'
      // }
      // store.commit('permission/CHANGE_ROUTES_ICON', data)
    },
    hasOneShowingChild: function hasOneShowingChild() {
      var _this4 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden || item.meta && item.meta.permissionTag && !hasAccess(item.meta.permissionTag)) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this4.onlyOneChild = item;
          return true;
        }
      });
      if (parent.meta && parent.meta.permissionTag && !hasAccess(parent.meta.permissionTag)) {
        return false;
      }

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return false;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    parentHasAccess: function parentHasAccess(parent) {
      return parent.children && parent.children.filter(function (v) {
        return !v.hidden;
      }).filter(function (v) {
        return !(v.meta && v.meta.permissionTag && !hasAccess(v.meta.permissionTag));
      }).length > 0;
    }
  }
};